// import { graphql, Link, StaticQuery } from "gatsby";
import PropTypes from "prop-types";
import React, { useMemo, useState } from "react";
import { Theme, Typography } from "@material-ui/core";
// import { useMediaQuery } from "@material-ui/core";

import { createStyles, makeStyles } from "@material-ui/core/styles";

import Property from "./Property";
import InfiniteScroll from "react-infinite-scroll-component";

// import PreviewCompatibleImage from "./PreviewCompatibleImage";

// const useStyles = makeStyles((theme: Theme) =>
//   createStyles({
//     root: {
//       display: "grid",
//       gap: `${theme.spacing(4)}px`,
//       [theme.breakpoints.up("sm")]: {
//         gridTemplateColumns: `repeat(4, 1fr)`
//       },
//       paddingBottom: theme.spacing(2),
//       paddingTop: theme.spacing(2)
//     }
//   })
// );

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    cards: {
      minWidth: "80vw",
      display: "grid",
      gap: `${theme.spacing(4)}px`,
      justifyItems: "center",
      [theme.breakpoints.up("sm")]: {
        gridTemplateColumns: `repeat(2, 1fr)`,
      },
      [theme.breakpoints.up("md")]: {
        gridTemplateColumns: `repeat(3, 1fr)`,
      },
      [theme.breakpoints.up("xl")]: {
        gridTemplateColumns: `repeat(3, 1fr)`,
      },
    },
    title: {
      margin: theme.spacing(4, 2, 2),
    },
  })
);

export const PropertyRoll = (
  {
    length,
    showTitle,
    page,
    setPage,
    currentList,
    filterOptions
  }: InferProps<typeof PropertyRoll.propTypes> = {
      showTitle: false,
    }
): ReactElement => {
  const classes = useStyles();
  return (
    <React.Fragment>
      {showTitle && (
        <Typography align="center" variant="h4" component="h1" gutterBottom>
          Properties
        </Typography>
      )}
      <InfiniteScroll
        className={classes.cards}
        hasMore={length > currentList?.length}
        next={() => setPage(page + 1)}
        dataLength={currentList?.length}
        scrollThreshold={0.8}
      >
        {currentList?.length
          ? currentList?.map(({ node: property }, key) => (
            <Property key={key} property={property} filterOptions={filterOptions}/>
          ))
          : null}
      </InfiniteScroll>
    </React.Fragment>
  );
};

PropertyRoll.propTypes = {
  properties: PropTypes.array,
  page: PropTypes.number,
  setPage: PropTypes.func,
  currentList: PropTypes.array,
  length: PropTypes.number,
};

PropertyRoll.propTypes = {};

export default PropertyRoll;
